<template>
	<div>
		<vxe-modal v-model="modal_model" :title="modal_title" :width="modal_width" :height="modal_height" @show="modal_onshow" show-footer @hide="modal_onhide"
			destroy-on-close>
			<template #default>
				<vxe-grid v-if="list_gridOptions" v-bind="list_gridOptions" @toolbar-button-click="list_toolbarButtonClickEvent"></vxe-grid>
			</template>
			<template #footer>
				<vxe-button status="" content="返回" @click="modal_cancel"></vxe-button>
			</template>
		</vxe-modal>
	</div>
</template>
<style scoped>

</style>
<script>
	import listMixins from '@_system/components/base/mixins/list/list.js'
	import modalMixins from '@_system/components/base/mixins/modal/modal.js'
	export default {
		mixins: [listMixins,modalMixins],
		props: {
			goodscode: {
				default: () => {
					return []
				}
			},
		},
		data() {
			return {
				modal_title: '库存状况',
				modal_width:800,
				modal_height:600,
				modal_model:false,
				list_formConfig: [{
					field: 'warehouse',
					title: '仓库',
					span:12,
					itemRender: {
						name: '$warehouse',
						props:{
							multiple:true,
							collapseTags:false
						}
							
					}
				}],
				list_columns: [
					{
						type: 'seq',
						title: '#',
						width:50
					},
					{
						field: 'goodscode',
						title: '商品编码',
					},
					{
						field: 'goodsname',
						title: '商品名称',
					},
					{
						field: 'modelname',
						title: '规格型号',
					},
					{
						field: 'num',
						title: '销售数量',
					},
					{
						field: 'stock',
						title: '可用库存'
					},
					{
						field: 'diff',
						title: '差值',
						sortable:true
					},
					// {
					// 	title: '操作',
					// 	fixed: "right",
					// 	align: 'center',
					// 	width: 65,
					// 	slots: {
					// 		default: ({row}) => {
					// 			return [<el-button type = "text" size = "mini" onClick = {() => {this.ddcode(row)}}>凭证</el-button>]
					// 		}
					// 	}
					// }					
				]
				// list_footerField:[
				// 	{field:'needamount',toFixed:2}
				// ]
			}
		},
		watch: {

		},
		computed: {
			device() {
				return window.systemMethods.device()
			}
		},
		created() {

		},
		mounted() {
			
		},
		methods: {
			// list_beforeCreateGrid(gridOptions){
			// 	gridOptions.formConfig = false
			// },
			list(page,updateForm,other) {
				return new Promise((resolve) => {
					let goodscode = this.goodscode.map((item)=>{
						return item.goodscode
					})
					this.$api.offer.getStock({
						goodscode:goodscode,
						...updateForm,
					}).then((res)=>{
						res.forEach((item,index)=>{
							item.num = 0
							if(this.goodscode[index] && this.goodscode[index].goodscode == item.goodscode){
								item.num = this.goodscode[index].num
							}
							item.diff = item.stock - item.num
						})
						resolve({
							list: res
						})
					},()=>{
						resolve({
							list: []
						})
					})
				})
			},
			submit() {
				//this.init()
			},
			reset() {
				//this.init()
			}
		},
		components: {
			
		}
	}
</script>